export default __webpack_public_path__ + "static/media/hero-desktop-safari-PT.cd2b5473.png";